import React, { Component } from 'react'
//

export default class Logo extends Component {
    constructor () {
        super()
        this.state = {
            color1: '#000000',
            color2: '#82BC00'
        }
    }

    componentDidMount() {
        const intervalId = setInterval(this.timer, 2000)
        this.setState({ intervalId: intervalId })
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId)
    }

    timer = () =>{
        this.changeColor()
    }

    changeColor = () =>{
            const altColors = ['#82BC00', '#00AEEF', '#00B6AA']
            this.setState({ color2: altColors[ Math.floor(Math.random() * 3)] })
    }

    render (){
        return (
            <svg width={this.props.width} height={this.props.height} onLoad={this.changeColor} viewBox="103 0 32 32">
                <path fill={this.state.color1} d="M163.7,0c0,0,0,4.9,0,8.6c-1.7,0-22.6,0-22.6,0c-4,0-7.4,3.2-7.4,7V24c0,4,3.2,7,7.4,7h17.4
                    c4.2,0,7.4-3,7.4-7V0H163.7z M163.7,24c0,2.8-2.3,5-5.3,5H141c-3,0-5.3-2.1-5.3-5v-8.4c0-2.7,2.4-4.9,5.3-4.9c0,0,20.9,0,22.6,0
                    C163.7,17.3,163.7,24,163.7,24z"/>
                <path fill={this.state.color1} d="M79.2,8.3H60.7v2.2h18.4c3.3,0,5.6,2.3,5.6,5.5c0,0,0,0.1,0,0.1c-0.7,0-23.4,0-23.4,0c-4.2,0-7.8,3.4-7.8,7.3
                    c0,3.6,3.2,7.5,7.8,7.5h17.8c4.3,0,7.8-3.3,7.8-7.2V16C87,11.6,83.6,8.3,79.2,8.3z M84.8,23.7c0,2.7-2.6,5-5.6,5H61.4
                    c-2.9,0-5.6-2.5-5.6-5.3c0-2.8,2.6-5.2,5.6-5.2c0,0,22.7,0,23.4,0C84.8,18.9,84.8,23.7,84.8,23.7z"/>
                <path fill={this.state.color1} d="M38.6,8.3v10.9c0,1.2-0.1,5.9-0.2,7c-0.1,1.3-1.1,2.4-2.4,2.5c0,0-3,0.1-3,0.1h-5.9l-3-0.1
                    c-1.3-0.1-2.3-1.2-2.4-2.5c0,0-0.1-0.8-0.1-0.8c0,0-0.1-1.5-0.1-1.5l0-15.5h-2.3c0,0,0,15.5,0,15.5l-0.1,1.5c0,0-0.1,0.8-0.1,0.8
                    c-0.1,1.3-1.1,2.4-2.4,2.5c0,0-3,0.1-3,0.1H7.9l-3-0.1c-1.3-0.1-2.3-1.2-2.4-2.5c-0.1-1.1-0.2-5.8-0.2-7V8.3H0v10.9
                    c0,1,0.1,6,0.2,7.1c0.2,2,1.8,4.2,4.4,4.5c0,0,3.3,0.2,3.3,0.2h5.9l3.3-0.2c1.4-0.1,2.6-0.9,3.4-2.1c0.8,1.1,2,1.9,3.4,2.1
                    c0,0,3.3,0.2,3.3,0.2H33l3.3-0.2c2.7-0.3,4.2-2.5,4.4-4.5c0.1-1.2,0.2-6.1,0.2-7.1V8.3H38.6z"/>
                <path fill={this.state.color1} d="M109.3,8.3c-4.3,0-7.5,3-7.5,6.9V31h2.2V15.2c0-2.8,2.3-4.9,5.3-4.9h14.4v-2H109.3z"/>
                <path fill={this.state.color2} style={{transition: 'fill 1s linear'}} d="M219.4,16.1c0,0-22.7,0-23.4,0c0,0,0-0.1,0-0.1c0-3.2,2.4-5.5,5.6-5.5h18.4V8.3h-18.4c-4.5,0-7.8,3.3-7.8,7.7
                    v7.7c0,3.9,3.6,7.2,7.8,7.2h17.8c4.6,0,7.8-4,7.8-7.5C227.2,19.5,223.6,16.1,219.4,16.1z M219.4,28.8h-17.8c-3,0-5.6-2.4-5.6-5
                    c0,0,0-4.9,0-5.5c0.7,0,23.4,0,23.4,0c3,0,5.6,2.4,5.6,5.2C225,26.2,222.3,28.8,219.4,28.8z"/>
            </svg>
        )
    }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Logo.js